import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { When } from 'react-if';
import firebase from 'firebase';
import './styles.css';
import { ReactComponent as CloseAccountIcon } from './close-account-icon.svg';
import ConfirmationModal from '../elements/modal/NewConfirmModal';
import { useToggle } from 'react-use';

const CloseAccount = () => {
    const [confirmPopupOpens, toggleConfirmPopupStatus] = useToggle(false);

    const handleCloseButtonClick = useCallback(() => {
        toggleConfirmPopupStatus();
    }, [toggleConfirmPopupStatus]);

    const handleConfirmCloseButtonClick = useCallback(() => {
        return firebase.auth().currentUser.delete();
    }, []);

    return (
        <>
            <div className="d-flex flex-column w-100">
                <div className="close-account__header d-flex align-items-center px-2">
                    <CloseAccountIcon />
                    <span className="close-account__header-text">
                        <b className="mr-1">Close</b>
                        Validate Account
                    </span>
                </div>
                <div className="close-account__text p-5 d-flex justify-content-center align-items-center">
                    If you’d like to cancel your Validate account please click this link
                    <a className="ml-1" onClick={handleCloseButtonClick}>
                        cancel my account
                    </a>
                </div>
            </div>
            <When condition={confirmPopupOpens}>
                {() => (
                    <ConfirmationModal
                        renderIcon={() => <CloseAccountIcon />}
                        renderContent={() => (
                            <>
                                Are you sure you want to close your account?
                                <b className="ml-1">We’ll miss you!</b>
                            </>
                        )}
                        onConfirm={handleConfirmCloseButtonClick}
                        onCancel={handleCloseButtonClick}
                    />
                )}
            </When>
        </>
    );
};

CloseAccount.propTypes = {};

export default React.memo(CloseAccount);
